/** @format */
import { css } from 'styled-components';

import { CLOSE_BUTTON_CURVE_OFFSET, TRANSITION_NAME } from './constants';
import { getAnimationValue } from './style-helpers';
import { StyledTrayProps } from './types';

export const styles = ({ $isAnimating }: StyledTrayProps) => css`
    @keyframes ${TRANSITION_NAME} {
        from {
            transform: translateY(calc(100% + ${CLOSE_BUTTON_CURVE_OFFSET}));
        }

        to {
            transform: translateY(0%);
        }
    }

    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: var(--z-index-tray);
    animation-name: ${getAnimationValue($isAnimating, TRANSITION_NAME)};
    background-color: white;
    border-radius: var(--layout-spacing-16) var(--layout-spacing-16) 0 0;
    box-shadow: var(--effects-shadow-base);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: var(--layout-spacing-32);

    .tray-content {
        max-height: calc(100dvh - var(--layout-spacing-24));
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: calc(var(--layout-spacing-32) * -1);
    }

    .close-button {
        position: absolute;
        top: calc(var(--layout-spacing-8) * -1);
    }

    .close-button-curve {
        position: absolute;
        width: 8.2rem;
        top: calc(${CLOSE_BUTTON_CURVE_OFFSET} * -1);
    }
`;
